import React from 'react';
import 'twin.macro';
import { BoWithLocalFallbackCycle } from 'components/Bo/BoWithLocalFallbackCycle';
import Button from 'components/Buttons/Button';
import { PlusIcon } from '@heroicons/react/20/solid';
import { BoValues, isReferentielValuesEmpty } from 'components/Bo';
import { useTranslation } from 'react-i18next';

interface Props {
  value: BoValues;
  onChange: (v: BoValues) => void;
  titleValue: string;
  cycle?: string;
  boId: string;
  hasAteliers: boolean;
}

export function Referentiel(props: Props) {
  const { value, onChange, titleValue, cycle, boId, hasAteliers } = props;
  const { t } = useTranslation(['cahierJournal']);
  const [hide, setHide] = React.useState(
    hasAteliers && isReferentielValuesEmpty(value),
  );
  if (hide) {
    return (
      <Button
        onClick={() => setHide(false)}
        fill
        alignText="left"
        tw="-mt-4" // hack : we want to compensate the parent flex gap
        icon={PlusIcon}
        small
        minimal
      >
        {t('ateliers.modal.addReferentialItems')}
      </Button>
    );
  }
  return (
    <div>
      <BoWithLocalFallbackCycle
        suggestionParams={{
          title: titleValue,
        }}
        suggestionEntity="cj"
        cycle={cycle}
        boId={boId}
        values={value}
        onChange={onChange}
      />
    </div>
  );
}
